import React from "react";
import ReactDOM from "react-dom";
import App from "./components/App";
import "./styles/bootstrap.min.css";
import "./styles/index.scss";
import "react-alice-carousel/lib/alice-carousel.css";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
